module.exports = __webpack_public_path__ + "img/clothes_1.542e8741.jpg";